"use client";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { authService } from "~/connectors/auth.connector";

import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Close from "@mui/icons-material/Close";
import ExitToApp from "@mui/icons-material/ExitToApp";
import Person from "@mui/icons-material/Person";

export default function ImpersonationBanner() {
  const { data: session, update } = useSession();
  const router = useRouter();
  const theme = useTheme();
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);

  // Don't show if not impersonating or if dismissed
  if (!session?.user?.isImpersonating || dismissed) {
    return null;
  }

  const handleStopImpersonating = async () => {
    setLoading(true);
    try {
      const impersonatedUserId = session.user.id;

      await authService.stopImpersonate(session!, update);

      // Redirect to the impersonated user's page
      router.push(`/admin/utilizatori/${impersonatedUserId}`);
    } catch (error) {
      console.error("Error stopping impersonation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar + 1,
      }}
    >
      <Alert
        severity="warning"
        icon={<Person />}
        sx={{
          borderRadius: 0,
          display: "flex",
          alignItems: "center",
          "& .MuiAlert-message": {
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          },
        }}
        action={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              onClick={handleStopImpersonating}
              disabled={loading}
              startIcon={<ExitToApp />}
              sx={{ whiteSpace: "nowrap" }}
            >
              {loading ? "Se încarcă..." : "Stop"}
            </Button>
            <IconButton
              size="small"
              onClick={handleDismiss}
              color="inherit"
              sx={{ ml: 1 }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
        }
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {session.user.name || session.user.email}
        </Typography>
      </Alert>
    </Box>
  );
}
